"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../utils");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SrOnlyStyled = _utils.styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:not(:focus):not(:active) {\n    clip: rect(0 0 0 0);\n    clip-path: inset(100%);\n    height: 1px;\n    overflow: hidden;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n  }\n"])));

var SrOnly = function SrOnly(props) {
  return /*#__PURE__*/_react.default.createElement(SrOnlyStyled, props);
};

var _default = SrOnly;
exports.default = _default;